import { createFileRoute } from '@tanstack/react-router'
import { AlertTriangle } from 'lucide-react'
import type { JSX } from 'react'

import { PageContainer } from '@/components/layout/page-container'
import { useCurrentUser } from '@/lib/auth/store'

export const Route = createFileRoute('/_app/dashboard')({
  component: DashboardPage,
})

function DashboardPage(): JSX.Element {
  const user = useCurrentUser()

  return (
    <PageContainer>
      {user?.onboardingPending === true && (
        <div className="mb-6 flex items-start gap-2 sm:gap-3 rounded-lg border border-yellow-300 bg-yellow-50 px-3 py-3 sm:px-4 text-yellow-800 dark:border-yellow-700 dark:bg-yellow-950 dark:text-yellow-300">
          <AlertTriangle className="mt-0.5 size-5 shrink-0" />
          <div>
            <p className="font-semibold">Completa tu perfil para comenzar</p>
            <p className="mt-0.5 text-sm">
              Falta configurar tu perfil fiscal, régimen y suscripción antes de poder emitir
              facturas.
            </p>
          </div>
        </div>
      )}
      <p className="text-muted-foreground">Dashboard — placeholder</p>
    </PageContainer>
  )
}
